import { ActionTree } from "vuex";
import { State } from "./state";
import { create, filter, findOne, update, findAll } from "@/store/Crud/functions/actions";

const URL = "/region-specific-documents";

export default <ActionTree<State, any>>{
  filter,
  create,
  findOne,
  update,
  findAll,
};
